module.exports = __webpack_public_path__ + "assets/img/mecha-active-btn-aefa6409.png";